export type LayoutType = "auth" | "search";

export type UIVersion = "v1" | "crt" | "awx";
export type CurrencyFormatMode = "intl" | "custom";
export type PaymentProvider = "authorize" | "airwallex" | "stripe";
export type RouteElement = Record<
  string,
  {
    element: React.FC<React.PropsWithChildren>;
    layout: LayoutType;
    title?: string;
    uiVersion: UIVersion;
    crumbParams?: string[];
  }
>;

export const ROOT = "/";
export const SEARCH = `${ROOT}search`;
export const SEARCH_RESULTS = `${ROOT}search-results`;
export const CRUISE = `${SEARCH_RESULTS}/:cruiseId`;
export const ROOMS = `${CRUISE}/rooms`;
export const CABINS_SELECT = `${CRUISE}/cabin-select`;
export const PASSENGERS = `${CRUISE}/guests`;
export const PAYMENT = `${CRUISE}/payment`;
export const PAYMENT_CONFIRMATION = `${CRUISE}/payment-confirmation`;
export const LIABILITY_AND_CANCELLATION = `${ROOT}/terms-of-liability`;
